export const ADD_VIDEO = 'ADD_VIDEO'
export const SET_VIDEOS = 'SET_VIDEOS'
export const DELETE_VIDEO = 'DELETE_VIDEO'
export const SET_MARKET_SEGMENTS = 'SET_MARKET_SEGMENTS'
export const SET_INCOMPLETE_VIDEOS_COUNT = 'SET_INCOMPLETE_VIDEOS_COUNT'
export const UPDATE_INCOMPLETE_VIDEOS_COUNT = 'UPDATE_INCOMPLETE_VIDEOS_COUNT'



// WEBPACK FOOTER //
// ./src/store/modules/video/types.js